<template>
  <div class="folder" v-loading="loading" element-loading-text="上传中...">
    <!-- 链接 -->
    <div class="title">
      <span @click="clickTitle('no')">根目录</span>
      <span
        v-for="(item, index) of titleList"
        :key="index"
        @click="clickTitle(item)"
      >
        |{{ item.name }}
      </span>
    </div>
    <div v-if="$props.isnewFile" class="kcitem">
      <div class="item back" style="padding: 50px; height: 100%">
        <el-popover popper-class="mycs" trigger="click">
          <div class="mynew" @click="openXJ">新建文件夹</div>
          <div class="mynew" @click="openFile">本地上传</div>
          <!-- <div class="mynew" @click="dialogTableVisible2 = true">
            学校资源库导入
          </div> -->
          <div class="mynew" @click="dialogTableVisible1 = true">添加链接</div>
          <div slot="reference">
            <div class="icon">
              <i class="el-icon-circle-plus-outline" />
            </div>
            <span style="font-size: 16px; font-weight: 600">新增</span>
          </div>
        </el-popover>
      </div>
    </div>
    <div v-for="item in kclist" :key="item.coursewareId" class="kcitem">
      <div style="margin-bottom: 5px">
        <!-- 多选 -->
        <el-checkbox
          v-if="$props.ischeckout"
          :value="$props.changeValue"
          :label="item.coursewareId"
          @change="check(item.coursewareId)"
        >
          {{ '' }}
        </el-checkbox>
      </div>
      <div class="item" @click="openInfo(item)">
        <img :src="imgUrl" v-if="item.coursewareType == 1" />
        <el-image fit="cover" class="img" :src="item.coursewarePic" v-else>
          <div slot="error" class="image-slot">
            <SvgIcon style="width: 90px" icon-class="filesvg"></SvgIcon>
          </div>
        </el-image>
      </div>
      <div class="name">{{ item.coursewareName }}</div>
      <div class="num">
        {{ item.createName }}
        <el-popover popper-class="mycs" trigger="click">
          <div class="mynew" @click="changenameFN(item)">重命名</div>
          <div class="mynew" @click="delFn(item)">删除</div>
          <div slot="reference">
            <div v-if="$props.isnewFile">
              <i class="el-icon-more-outline" />
            </div>
          </div>
        </el-popover>
      </div>
    </div>
    <!-- 添加链接 -->
    <el-dialog
      width="30%"
      :append-to-body="true"
      title="重命名"
      :visible.sync="dialogTableVisible3"
    >
      <el-input v-model="resetName" placeholder="请输入资源名称" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="wjSubmit('edit')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新建文件夹 -->
    <el-dialog
      width="30%"
      :append-to-body="true"
      title="新建文件夹"
      :visible.sync="dialogTableVisible"
    >
      <el-form label-position="right">
        <el-form-item label="文件夹名称:">
          <el-input v-model="wj.coursewareName" placeholder="请输入文件名" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="wjSubmit('add')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加链接 -->
    <el-dialog
      width="30%"
      :append-to-body="true"
      title="添加链接"
      :visible.sync="dialogTableVisible1"
    >
      <el-form label-position="right">
        <el-form-item label="资源名称:">
          <el-input v-model="lj.coursewareName" placeholder="请输入资源名称" />
        </el-form-item>
        <el-form-item label="资源URL:">
          <el-input v-model="lj.coursewarePic" placeholder="请输入资源URL" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submitLian">确 定</el-button>
      </div>
    </el-dialog>
    <FileExplorer v-model="dialogTableVisible2" @changefn="changefn" />
    <el-upload
      ref="upload"
      class="upload-demo"
      action="#"
      :limit="1"
      :file-list="fileList"
      :on-change="changeHandle"
      :auto-upload="false"
      list-type="picture"
      :show-file-list="false"
    >
      <i class="el-icon-upload2" style="display: none" />
    </el-upload>
    <vaidio v-model="value" :type="zytype" :detail="detail" />
  </div>
</template>

<script>
import SvgIcon from './SvgIcon'
import FileExplorer from '@/components/common/FileExplorer.vue'
import vaidio from '@/components/alldetaildlag/vaidio.vue'
import {
  coursewareFolderAdd,
  coursewareUpd,
  coursewareDel,
  coursewareLinkAdd,
  fileUpload,
  coursewareFolderAgainAdd,
  coursewareFolderList,
  coursewareLinkAgainAdd,
  fileAgainUpload,
} from '@/api/courseinfo'
import file from '@/assets/img/file.png'
export default {
  // 组件名称
  name: 'Folder',
  components: {
    SvgIcon,
    FileExplorer,
    vaidio,
  },
  props: {
    isnewFile: {
      type: Boolean,
      default: false,
    },
    ischeckout: {
      type: Boolean,
      default: false,
    },
    kclist: {
      type: Array,
      default: () => [],
    },
    changeValue: {
      type: Array,
      default: () => [],
    },
    param: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      zytype: '',
      detail: '',
      value: false,
      resetName: '', // 重命名
      dialogTableVisible3: false, // 重命名弹窗
      dialogTableVisible: false, // 新建文件夹
      dialogTableVisible1: false, // 添加链接
      dialogTableVisible2: false,
      wj: {
        // 文件
        coursewareName: '',
        coursewarePrintId: '',
      },
      loading: false,
      coursewareId: '',
      type: '',
      lj: {
        // 链接
        coursewareName: '',
        coursewarePic: '',
      },
      imgUrl: file,
      fileList: [],
      titleList: [],
      file: '',
    }
  },
  methods: {
    // 新建文件夹
    async wjSubmit(type) {
      const courseId = this.$store.state.courseId
      if (type === 'add') {
        if (this.wj.coursewareName === '') {
          return this.$message.error('填写文件夹名称')
        }
        let res
        if (this.$props.param.coursewarePrintId) {
          this.wj.coursewarePrintId = this.$props.param.coursewareId
          res = await coursewareFolderAgainAdd(
            courseId,
            this.$props.param.coursewarePrintId,
            this.wj
          )
        } else {
          res = await coursewareFolderAdd(courseId, this.wj)
        }
        if (res.code === 500) return this.$message.error(res.message)
        this.$message.success('新建文件夹成功')
        this.dialogTableVisible = false
        this.$emit('getList')
      } else {
        if (this.resetName === '') {
          return this.$message.error('填写重命名')
        }
        const data = {
          coursewareId: this.coursewareId,
          coursewareName: this.resetName,
        }
        const res = await coursewareUpd(data)
        if (res.code === 500) return this.$message.error(res.message)
        this.$message.success('修改成功')
        this.coursewareId = ''
        this.dialogTableVisible3 = false
        this.$emit('getList')
      }
    },
    async submitLian() {
      const courseId = this.$store.state.courseId
      let res
      if (this.$props.param.coursewarePrintId) {
        res = await coursewareLinkAgainAdd(
          courseId,
          this.$props.param.coursewarePrintId,
          this.lj
        )
      } else {
        res = await coursewareLinkAdd(courseId, this.lj)
      }
      if (res.code === 500) return this.$message.error(res.message)
      this.$message.success('新建文件夹成功')
      this.dialogTableVisible1 = false
      this.$emit('getList')
    },
    // 获取文件夹下列表
    async getFolderList() {
      const courseId = this.$store.state.courseId
      const res = await coursewareFolderList(
        courseId,
        this.$props.param.coursewarePrintId,
        this.param
      )
      if (res.code === 500) return this.$message.error(res.message)
      this.$props.kclist = res.data.list
    },
    // 打开弹框
    openXJ() {
      this.dialogTableVisible = true
    },
    // 触发上传文件
    openFile() {
      this.$refs['upload'].$refs['upload-inner'].handleClick()
    },
    // 重命名
    changenameFN(item) {
      this.dialogTableVisible3 = true
      this.coursewareId = item.coursewareId
    },
    // 删除文件
    delFn(item) {
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.coursewareId = item.coursewareId
          const data = {
            coursewareIds: this.coursewareId,
          }
          // data.coursewareIds.push(this.coursewareId)
          const res = await coursewareDel(data)
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.$emit('getList')
          }
        })
        .catch(() => {
          this.coursewareId = ''
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    indexOf(val, ids) {
      for (let i = 0; i < ids.length; i++) {
        // 获取当前值的下标
        if (ids[i] === val) {
          return i
        }
      }
      return -1
    },
    check(val) {
      const index = this.indexOf(val, this.$props.changeValue)
      if (this.changeValue.length > 0 && index > -1) {
        this.$props.changeValue.splice(index, 1)
      } else {
        this.$props.changeValue.push(val)
      }
      this.$emit('delList', this.$props.changeValue)
    },
    // 关闭资源弹窗
    changefn(str) {
      this.dialogTableVisible2 = str
    },
    openInfo(item) {
      if (item.coursewareType == 1) {
        this.$props.param.coursewarePrintId = item.coursewareId
        this.$props.param.coursewareType = item.coursewareId
        this.$emit('getList')
        const data = {
          name: item.coursewareName,
          id: item.coursewareId,
        }
        const index = this.titleList.findIndex((ele) => ele.id == data.id)
        if (index < 0) {
          this.titleList.push(data)
        }
      } else {
        const filetypearr = ['mp4', 'png', 'jpg']
        const filetype =
          item.coursewarePic.split('.')[
            item.coursewarePic.split('.').length - 1
          ]
        if (filetypearr.includes(filetype)) {
          this.detail = item.coursewarePic
          this.zytype = 'img'
          if (filetype == 'mp4') {
            this.zytype = 'mp4'
          }
          this.value = true
        } else {
          window.open(item.coursewarePic)
        }
      }
    },
    // 文件上传
    async changeHandle(files) {
      const filetypearr = ['png', 'jpg', 'jpeg']
      const filetype = files.name.split('.')[files.name.split('.').length - 1]
      const filesize = files.size / 1024 / 1024
      this.fileList = []
      if (!filetypearr.includes(filetype)) {
        this.fileList = []
        return this.$message.error('文件格式应为 png jpg jpeg')
      }
      if (filetype == 'mp4') {
        if (filesize > 20) {
          this.fileList = []
          return this.$message.error('视频文件应小于20MB')
        }
      } else {
        if (filesize > 5) {
          this.fileList = []
          return this.$message.error('文件文件应小于5MB')
        }
      }
      this.loading = true
      this.file = files
      const courseId = this.$store.state.courseId
      let param = new FormData()
      param.append('file', this.file.raw)
      try {
        if (this.$props.param.coursewarePrintId) {
          await fileAgainUpload(
            courseId,
            this.$props.param.coursewarePrintId,
            param
          )
          this.loading = false
        } else {
          await fileUpload(courseId, param)
          this.loading = false
        }
        this.fileList = []
        this.$emit('getList')
      } catch (error) {
        this.loading = false
        this.fileList = []
      }
    },
    clickTitle(item) {
      if (item === 'no') {
        this.titleList = []
        this.$props.param.coursewarePrintId = 0
      } else {
        const index = this.titleList.findIndex((ele) => ele.id === item.id)
        this.titleList.splice(index + 1, this.titleList.length)
        this.$props.param.coursewarePrintId = item.id
        this.$props.param.coursewareType = item.id
      }
      this.$emit('getList')
    },
  },
}
</script>

<style scoped lang="scss">
.folder {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}
.kcitem {
  width: 210px;
  border: 1px solid #d8e0f0;
  padding: 10px;
  background-color: white;
  margin-right: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  border-radius: 12px;
  .back {
    background-color: #f4f9fd;
    border-radius: 12px;
  }
  .item {
    width: 100%;
    height: 152px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .img {
      max-width: 100%;
      max-height: 100%;
    }
    .icon {
      color: var(--textgray);
      font-size: 95px;
      margin-bottom: 5px;
      width: 100%;
      // font-size: 80px;
    }
  }
  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
    word-break: break-all;
    font-weight: 600;
    height: 39px;
    font-size: 16px;
  }
  .num {
    font-size: 14px;
    width: 100%;
    padding: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      transform: rotateZ(90deg);
    }
  }
}
</style>
<style>
.mycs {
  min-width: 100px;
  text-align: center;
  .mynew {
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }
  .mynew:hover {
    color: var(--primary);
  }
}
</style>
